import { saveLocale } from '../../../../services/storage-window'

export default {
    UPDATE_LOCALE (state, payload) {
        state.locale = payload
        saveLocale(payload)
    },
    
}